import { Block } from "modules/Block";
import { equalizeHeight } from "modules/dom";

import bundleFilterTemplate from "./BundlingBlockFilterTemplate.hbs";
import bundleTemplate from "./BundlingBlockTemplate.hbs";

import "./bundling-block.scss";

export class BundlingBlock extends Block<typeof BundlingBlock> {
    static readonly className = "js-bundling-block";

    constructor(rootElement: HTMLElement, index: number) {
        super(rootElement, index);

        this.triggerPricingModal();
        this.toggleBundleFilter();
        this.equalHeight();
    }

    toggleBundleFilter() {
        const filter = this.rootElement.querySelector<HTMLSpanElement>(".js-bundle-filter");
        const labels = filter?.querySelectorAll("label");

        if (!labels) return;

        labels.forEach((label, labelIndex) => {
            const input = label.previousElementSibling;
            const id = `bundle-filter-${this.index}-${labelIndex}`;

            if (!input || !(input instanceof HTMLInputElement)) return;

            label.htmlFor = id;
            input.id = id;

            label.addEventListener("click", this.handleBundleFilterLabelClick);
        });
    }

    handleBundleFilterLabelClick = (e: MouseEvent) => {
        const label = e.currentTarget;
        if (!label || !(label instanceof HTMLElement)) return;

        const input = label.previousElementSibling;
        if (!input || !(input instanceof HTMLInputElement)) return;

        if (!input.checked) {
            if (input.value === "monthly") {
                this.rootElement.classList.add("monthly");
                this.rootElement.classList.remove("yearly");
            }
            else {
                this.rootElement.classList.remove("monthly");
                this.rootElement.classList.add("yearly");
            }
        }
    }

    triggerPricingModal() {
        const buttons = this.rootElement.querySelectorAll(".js-pricing-modal-trigger");

        buttons.forEach((button) => {
            button.addEventListener("click", (e) => {
                const button = e.currentTarget;

                if (!button || !(button instanceof HTMLButtonElement)) return;

                const id = button.dataset.id;
                let modal = this.rootElement.querySelector<HTMLDivElement>("[data-formid='" + id + "']");

                if (modal === null) {
                    modal = this.rootElement.querySelector<HTMLDivElement>(".js-pricing-modal-block");
                }

                if (!modal) return;

                const selectedItem = button.closest(".js-bundle-data")?.querySelector<HTMLSpanElement>(".bundle-title")?.innerText || "";

                modal.style.display = "flex";

                this.renderPricingModalContent(selectedItem);

                modal.addEventListener("click", (e) => {
                    const modal = e.currentTarget;
                    const target = e.target;

                    if (
                        !target || !(target instanceof HTMLElement) || !modal || !(modal instanceof HTMLDivElement)
                    ) {
                        return;
                    }

                    if (target.classList.contains("modal-form__close") || target.classList.contains("js-pricing-modal-block")) {
                        modal.style.display = "none";
                    }
                });
            })
        });
    }

    renderPricingModalContent(selectedItem: string) {
        const packages = this.rootElement.querySelectorAll<HTMLDivElement>(".js-bundle-data");
        const dataTargetContent = this.rootElement.querySelector<HTMLElement>(".js-pricing-modal-content");
        const dataTargetFilters = this.rootElement.querySelector<HTMLElement>(".js-pricing-filters");
        const data: any[] = [];

        packages.forEach((p) => {
            const packageTitle = p.querySelector<HTMLSpanElement>(".bundle-title")?.innerText;
            const isSelected = selectedItem === packageTitle;

            const obj = {
                "title": packageTitle,
                "text": p.querySelector<HTMLElement>(".bundle-description")?.innerText,
                "price": p.querySelector<HTMLElement>(".js-price-month")?.innerText,
                "priceLabel": p.querySelector<HTMLElement>(".js-price-month.price-label")?.innerText,
                "isHighlight": p.closest(".card")?.classList.contains("is-highlight"),
                "selected": isSelected
            }

            data.push(obj);
        });

        if (dataTargetContent !== null && dataTargetFilters !== null) {
            dataTargetContent.innerHTML = bundleTemplate(data);
            dataTargetFilters.innerHTML = bundleFilterTemplate(data);
        }

        this.updateHiddenInput(selectedItem);
        this.togglePackagePricingFilters();
    }

    // Set the hidden input to the selected title after re-rendering content
    updateHiddenInput(selectedTitle: string) {
        const formBlock = this.rootElement.querySelector<HTMLElement>(".form-block");
        const hiddenInput = formBlock?.querySelector<HTMLInputElement>('input.PricingInformation');
        if (hiddenInput != null) {
            hiddenInput.value = ""; // Clear previous value first
            hiddenInput.value = selectedTitle; // Set hidden input to the new title
        }
    }

    togglePackagePricingFilters() {
        const packagePricingFilters = this.rootElement.querySelector(".js-pricing-filters");
        const labels = packagePricingFilters?.querySelectorAll<HTMLElement>(".pricing-filter-label");

        labels?.forEach((label) => {
            label.addEventListener("click", this.handlePricingFilterLabelClick);
        })
    }

    handlePricingFilterLabelClick(e: MouseEvent) {
        const label = e.currentTarget;

        if (!label || !(label instanceof HTMLLabelElement)) return;

        const id = label.htmlFor;
        const parent = label.closest(".js-pricing-modal-block");
        const formBlock = parent?.querySelector(".form-block");
        const hiddenInput = formBlock?.querySelector<HTMLInputElement>('input.PricingInformation');

        if (hiddenInput != null) {
            hiddenInput.value = ""; // Clear previous value first
            hiddenInput.value = label.innerText; // Set hidden input to the new title
        }

        const prices = parent?.querySelectorAll(".price-info");
        const target = parent?.querySelector(`.price-info[data-id='${id}']`);

        prices?.forEach((price) => {
            price.classList.add("hidden");
        });

        target?.classList.remove("hidden");
    }

    equalHeight() {
        equalizeHeight('.bundle-top', this.rootElement);
        equalizeHeight('.bundle-data', this.rootElement);
    }
}